/** Return links stay inside Renteller, including after URL normalization. */
export function safeReturnTo(value: unknown): string | undefined {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    /[\u0000-\u0020\u007f]/.test(value)
  )
    return;
  const origin = "https://renteller.invalid";
  const target = new URL(value, origin);
  if (target.origin !== origin || target.pathname === "/signin") return;
  return target.pathname + target.search + target.hash;
}
